export default "__VITE_ASSET__BGZgky3l__"